import { configureStore } from '@reduxjs/toolkit'
import userReducer from './slices/userSlice'
import pptReducer from './slices/pptSlice'

export const store = configureStore({
  reducer: {
    user: userReducer,
    ppt: pptReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
